import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-03 — pola obowiązkowe wyróżnione krojem pisma (decyzja z paczki p. Mariusza 15.10; scenariusz e2e 26).
 * Prezlecenia G1R (zwrócone do CS), C1 (u CS, przed akceptacją) i G1Q (u Administracji) z
 * `e2e/setup/scenario-state.mjs`. Nagrywarka tylko otwiera „Popraw dane”.
 */
const PRE_ORDER: GuideRecordHint = {
  description: 'prezlecenie u CS albo zwrócone do CS',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'cs_returned' },
};
/** „Popraw dane” jest tylko przed akceptacją prezlecenia. */
const BEFORE_ACCEPTANCE: GuideRecordHint = {
  description: 'prezlecenie u CS, jeszcze niezaakceptowane — z kolejki „Do uzupełnienia”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'cs_todo' },
};
const CONTROL: GuideRecordHint = {
  description: 'prezlecenie u Administracji — z kolejki „Do kontroli”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'adm_control' },
};

export const guide: Guide = {
  flagKey: 'requiredFieldsHighlight',
  title: 'Pola obowiązkowe wyróżnione krojem pisma',
  whatItDoes:
    'Na prezleceniu, w „Danych dla importera” i w oknie kontroli Administracji nazwy pól obowiązkowych są półgrube, a czytnik ekranu dopowiada „pole obowiązkowe”. Lista pól jest jedna: to pola, bez których prezlecenia nie da się zaakceptować albo importer VIA nie przyjmie pliku — ta sama lista co braki blokujące przekazanie. Puste pole obowiązkowe ma dalej oznaczenie braku.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-24.10-03'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: PRE_ORDER,
      target: 'pre-order-form-side',
      title: 'Prezlecenie: nazwy pól obowiązkowych',
      description: 'Klient, numer zamówienia klienta, załadunek, rozładunek, waga, cena i spółka mają półgrube nazwy.',
      action: 'Otwórz prezlecenie i spójrz na sekcję „Prezlecenie”.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'g1rPreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: BEFORE_ACCEPTANCE,
      target: 'cs-zlecenie-punkt-2-godziny',
      title: 'Formularz „Popraw dane”',
      description:
        'W formularzu pola obowiązkowe wyróżnia ta sama czcionka — od razu widać, co trzeba wypełnić przed przekazaniem.',
      action: 'Kliknij „Popraw dane”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'c1PreOrderId' },
        actions: [{ kind: 'clickButton', name: 'Popraw dane' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'intake-control-window',
      title: 'Okno kontroli Administracji',
      description: 'W oknie kontroli wiersze pól obowiązkowych mają te same wyróżnione nazwy.',
      action: 'Otwórz okno kontroli prezlecenia z kolejki „Do kontroli”.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'g1qPreOrderId' } },
    },
  ],
};
